import React, { Fragment, Component } from 'react'
import {
    Row, Col,
    Button
} from "reactstrap"
import classnames from 'classnames'
import { ConfirmAlert } from '../../../../../helpers/ui/alert'
import Select from '../../../../../helpers/ui/CustomSelect'
import { AvForm, AvField, AvGroup, AvCheckboxGroup, AvCheckbox, AvInput } from "availity-reactstrap-validation"
import CustomSelect from '../../../../../helpers/ui/CustomSelect'
import { Link, useHistory, Redirect } from "react-router-dom"

import apiResponse from '../../../../../services/apiResponse'
import { cancelToken } from '../../../../../services/adapters/kepegawaian/menuService'

import IndexBloc from '../../Index/Blocs/IndexBloc'
import UpdateBloc from '../Blocs/UpdateBloc'
import { combineAll } from 'rxjs/operators'

class ManajerialComponent extends Component {

    updateBloc = new UpdateBloc()
    indexBloc = new IndexBloc()
    source
    timer
    constructor(props) {
        super(props)
        this.state = {
            detail: [],
            detailstankom: [
                {
                    competence: '',
                    competencename:'',
                    levelname:'',
                    level: 0,
                }
            ],
            kompetensilist: [
                {
                    kompetensiuuid: '',
                    kompetensiname:'',
                }
            ],
            kompetensilevel: [
                {
                    level: '',
                    levelname:'',
                }
            ],
            list: [],
            dataForm: {},
            isLoading: 0,
        }
    }

    addStankom = () => {
        let count = this.state.detailstankom.length;
        this.setState({
            detailstankom: [
                ...this.state.detailstankom,
                {
                    competence : count == 0 ? (count+1) : this.state.detailstankom.slice(-1)[0].competence,
                    competencename : count == 0 ? (count+1) : this.state.detailstankom.slice(-1)[0].competencename,
                    level : count == 0 ? (count+1) : this.state.detailstankom.slice(-1)[0].level,
                    levelname : count == 0 ? (count+1) : this.state.detailstankom.slice(-1)[0].levelname
                }
            ]
        })

        console.log(this.state.detailstankom)
    }

    delStankom = (data) => {
        let count = this.state.detailstankom.length-1;
        this.setState({
            detailstankom: [
                ...this.state.detailstankom.filter((val) => val!=data)
                
                // (count-1)
            ]
        })
    }

    reformatStankom = (raw) => {
        return raw.map(function(data) {
          var newObj = {};
          newObj["competence"] = data.stancom_competence_uuid;
          newObj["competencename"] = data.competence_name;
          newObj["level"] = data.stancom_competence_level;
          newObj["levelname"] = data.level_name;
      
          return newObj;
        });
    }
    reformatLevel = (raw) => {
        return raw.map(function(data) {
          var newObj = {};
          newObj["label"] = `Level-${(data.level_no==0)?data.level_no+1:data.level_no}-${data.level_name}`;
          newObj["value"] = data.level_no;
      
          return newObj;
        });
    }

    reformatOptions = function(raw, label, value) {
        return raw.map(function(data) {
          var newObj = {};
          newObj["label"] = data[label];
          newObj["value"] = data[value];
      
          return newObj;
        });
      };

    handleChangeInputStankom = (e, index) => {
        // 1. Make a shallow copy of the items
        let items = [...this.state.detailstankom];
        // 2. Make a shallow copy of the item you want to mutate
        let item = {...items[index]};
        // 3. Replace the property you're intested in
        item.name = e.target.value;
        // 4. Put it back into our array. N.B. we *are* mutating the array here, but that's why we made a copy first
        items[index] = item;
        // 5. Set the state to our new copy
        this.setState({detailstankom : items});
    }

    toggle = tab => {
        if(this.state.activeTab !== tab) this.setState({activeTab:tab});
    }

    submitData = async () => {
        await this.updateBloc.fetchUpdate(this.state.dataForm)
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }

    loadDetail = async () => {
        const query = {
            uuid: this.props.uuid
        }

        await this.indexBloc.fetchDetail(query)
    }

    loadDetailStankom = async () => {
        const query = {
            uuid: this.props.uuid,
            type: 1
        }

        await this.updateBloc.fetchDetailStankom(query)
    }
    loadKompetensi = async () => {
        const query = {
            uuid: this.props.uuid,
            type: 1
        }

        await this.updateBloc.fetchKompetensiList(query)
    }

    handleChangeCompetence = async (e, index) => {

        const query = {
            uuid: e.value,
            index: index
            // type: 1
        }

        console.log(e.value)
        console.log('-->'+index)
        
        await this.updateBloc.fetchKompetensiLevel(query)
    }
    loadlevel = async (competenceuuid, index) => {

        const query = {
            uuid: competenceuuid,
            index: index
            // type: 1
        }

        // console.log(e.value)
        
        await this.updateBloc.fetchKompetensiLevel(query)
    }
    
    handleOnLoadcompetence = async (e, index) => {

        const query = {
            uuid: e.value,
            // type: 1
        }

        console.log(e.value)
        
        await this.updateBloc.fetchKompetensiLevel(query)
    }

    handlerOnSubmitManajerial = (e, values) => {
        e.preventDefault()
        this.setState({
            dataForm: {
                position_uuid: this.props.uuid,
                ...values
            },
            confirm: true
        })
    }

    componentDidMount() {

        this.loadDetail()
        this.loadDetailStankom()
        this.loadKompetensi()

        this.indexBloc.detailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ detail: result.data.response })
                    break;
                case apiResponse.ERROR:
                    break;
                default:
                    break;
            }
        })
        this.updateBloc.detailStankomChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    let resp = result.data.response;
                    // console.log('----detail manajerial-----')
                    // console.log(resp)

                    if (resp.length > 0){
                        this.setState({ 
                            detailstankom : this.reformatStankom(resp)
                        })

                        resp.map( (data, index) => {
                            this.loadlevel(data.competence_uuid, index)
                        });
                    }

                    break;
                case apiResponse.ERROR:
                    break;
                default:
                    break;
            }
        })
        this.updateBloc.kompetensiChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    let resp = result.data.response;

                    console.log(resp)

                    this.setState({
                        kompetensilist : this.reformatOptions(
                            resp, 
                            'competence_name',
                            'competence_uuid'
                        )
                    })

                    break;
                case apiResponse.ERROR:
                    break;
                default:
                    break;
            }
        })

        this.updateBloc.updateChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

        this.updateBloc.kompetensiLevelChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    let resp = result.data.response;
                    let msg = result.data.message;
                    
                    //console.log(resp)
                    
                    this.setState({
                        ["kompetensilevel"+msg.index] : this.reformatLevel(resp)
                    })
                        
                break;
                case apiResponse.ERROR:
                    break;
                default:
                    break;
            }
        })

    }

    componentWillUnmount() {
        this.indexBloc.detailChannel?.unsubscribe()
        this.indexBloc.updateChannel?.unsubscribe()
    }

    render() {
        const { detail, list } = this.state
        const { result, total } = list
       
        return (
            <Fragment>
                <AvForm
                    className="needs-validation"
                    onValidSubmit={(e, values) => this.handlerOnSubmitManajerial(e, values)}
                >
                    <Col md="12">
                            <div className="row" style={{padding:'15px'}}>
                                <div className="col-md-5 text-bold">
                                    <b>Standar Kompetensi Manajerial</b>
                                </div>
                            </div>
                        </Col>
                    <Row className="mb-12">
                        <AvField
                            name="tipe"
                            type="hidden"
                            id="tipe"
                            value="1"
                        />
                        <AvField
                            name="position_uuid"
                            type="hidden"
                            value={detail?.position_uuid}
                            validate={{ required: { value: true } }}
                            readOnly={true}
                        />
                        <Col md="12">
                            <div className="row" style={{padding:'15px'}}>
                                <div className="col-md-5 text-bold">
                                    <b>Kompetensi</b>
                                </div>
                                <div className="col-md-5 text-bold">
                                    <b>Level</b>
                                </div>
                                <div className="col-md-2 text-bold">
                                    <b>&nbsp;&nbsp;&nbsp; Aksi</b>
                                </div>
                            </div>
                            {
                                this.state.detailstankom.map((data, index) => {
                                    return (
                                        <div className="row">
                                            <div className="col-md-5">
                                            
                                                <CustomSelect 
                                                    name={`kompetensiuuid[${index}]`}
                                                    errorMessage="Pilih Kompetensi"
                                                    options={this.state.kompetensilist} 
                                                    placeholder="Pilih Kompetensi"
                                                    onChange={(e) => {
                                                        this.handleChangeCompetence(e, index)
                                                    }}
                                                    // value={data.kompetensiuuid}
                                                    defaultValue={data.competence}
                                                />
                                            </div>
                                            <div className="col-md-5">
                                                <CustomSelect 
                                                    name={`kompetensilevel[${index}]`}
                                                    errorMessage="Pilih Level"
                                                    options={this.state["kompetensilevel" + index] ?? this.state.kompetensilevel} 
                                                    placeholder="Pilih Level"
                                                    defaultValue={data.level}
                                                />
                                            </div>
                                            <div className="col-md-2 text-right">
                                                {
                                                    index == 0 ? 
                                                    <div className="col-md-2 text-right">
                                                        <Button className="btn-block waves-effect waves-light mb-1 btn btn-primary"
                                                            color="success" 
                                                            type="button"
                                                            onClick={this.addStankom}
                                                            ><i className="uil-plus-circle"></i>
                                                        </Button>
                                                    </div> :
                                                        <Button className="btn-block waves-effect waves-light mb-1 btn btn-primary"
                                                            color="danger" 
                                                            type="button"
                                                            onClick={() => {
                                                                this.delStankom(data)
                                                            }}
                                                            ><i className="uil-trash-alt"></i>
                                                        </Button>
                                                }
                                                
                                            </div>
                                        </div>
                                    )    
                                })
                            }
                            {/* <AvField
                                name="work_unit_name"
                                placeholder="Nama Struktur Organisasi"
                                errorMessage="Masukkan Struktur Organisasi"
                                type="text"
                                className="form-control"
                                value={detail?.work_unit_name}
                                validate={{ required: { value: true } }}
                                readOnly={true}
                            /> */}
                            
                        </Col>
                    </Row>
                    <Row className="mb-3" style={{padding:'25px'}}>
                        <Col md="3"></Col>
                        <Col md="9">
                            <Link to="/master/standar_kompetensi.html">
                                <Button color="danger" type="button"><i className="uil-arrow-left"></i> Kembali</Button>
                            </Link>
                            {' '}
                            <Button color="success" type="submit">
                                <i className="uil-arrow-up-right"></i> Simpan Data
                            </Button>
                        </Col>
                    </Row>
                </AvForm>
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menyimpan data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.redirect ?
                    null// <Redirect to='/master/standar_kompetensi.html'/>
                : null }
            </Fragment>
        )
    }


}

export default ManajerialComponent
